// Fuel Type Constants for FusionCab - Backend Compatible
//
// Mirrors fusion_backend's FUEL_TYPES (src/constants/fleetConstants.js) plus
// the 'any' value Price.js appends to its own fuel_type enum on top of that
// list - a Price row with fuel_type "any" is fulfillable with any fuel, so
// it isn't itself a filter choice (see FUEL_TYPE_OPTIONS below), but it must
// still match every fuel-type filter (see Dashboard.tsx's filteredResults).

export const FUEL_TYPES = {
  PETROL: "Petrol",
  DIESEL: "Diesel",
  CNG_PETROL: "CNG/Petrol",
  HYBRID: "Hybrid",
  ELECTRIC: "Electric",
  ANY: "any",
} as const;

export type FuelType = (typeof FUEL_TYPES)[keyof typeof FUEL_TYPES];

// User-facing filter options (excludes "any", which is a wildcard match, not a filter choice)
export const FUEL_TYPE_OPTIONS: { value: Exclude<FuelType, "any">; label: string }[] = [
  { value: FUEL_TYPES.PETROL, label: "Petrol" },
  { value: FUEL_TYPES.DIESEL, label: "Diesel" },
  { value: FUEL_TYPES.CNG_PETROL, label: "CNG/Petrol" },
  { value: FUEL_TYPES.HYBRID, label: "Hybrid" },
  { value: FUEL_TYPES.ELECTRIC, label: "Electric" },
];
